<nav class="navbar secondary navbar-transparent k-display-block k-pl-4 k-pr-4">
  <div class="navigation">
    <ul class="navbar-nav k-mt-0 k-flex-row k-justify-content-around k-align-items-center">
      <li class="nav-item">
        <a class="nav-link text-decoration-none user-select-none">
          <span class="icon notifications"></span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link pe-0" (click)="openContextMenu()" #contextMenu>
          <app-shive-avatar [user]="user()" />
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link text-decoration-none user-select-none"
          [routerLink]="'/' + ShiveRoutes.SettingsNonworkingTime"
        >
          <span class="icon settings"></span>
        </a>
      </li>
    </ul>
  </div>
</nav>

<ng-template #contextMenuHeader>
  <div id="profile-menu-header" class="k-d-flex k-flex-col k-align-items-center k-py-4">
    <app-shive-avatar [user]="user()" [width]="45" [height]="45" />
    <div class="fullname k-mt-2 k-font-weight-semibold">
      <span>{{ user().firstName }}</span
      >&nbsp;
      <span>{{ user().lastName }}</span>
    </div>

    <div class="email k-font-weight-extra-light">
      <span>{{ user().email }}</span>
    </div>
  </div>
</ng-template>

<ng-template #contextMenuFooter>
  <div id="profile-menu-footer" class="k-d-flex k-flex-col k-align-items-center" (click)="logout()">
    <div class="context-item k-d-flex k-w-full" role="button">
      <span class="icon-button k-d-flex k-align-items-center">
        <fa-icon class="k-mr-3 turquoise" [icon]="faRightFromBracket"></fa-icon>
      </span>
      <span>Abmelden</span>
    </div>
  </div>
</ng-template>
